<template>
  <v-container>
      <v-row align="center" dense>
        <v-col cols="12" sm="3" class="d-none d-sm-block text-sm-left">
        </v-col>
         <v-col cols="12" sm="6" class="text-center">
          <h1 class="text-center mb-1">Runen Shop</h1>
        </v-col>
        <v-col cols="12" sm="3" class="text-center text-sm-right">
          <v-btn @click="toEquipmentView" color="success" :block="$vuetify.breakpoint.xsOnly">Zur Charakterausrüstung</v-btn>
        </v-col>
    </v-row>
    <div class="mt-4">
      <user-stats-bar
        :username="$store.state.username"
        :xp-name="$store.state.xp_name ?? 'XP'"
        :xp-value="$store.state.xp ?? 0"
      />
      <v-app>
        <v-container>
          <v-row align="stretch">
            <v-col v-for="(rune, index) in runes" :key="index" cols="12" sm="6" md="3" class="d-flex">
              <v-card class="pa-3 d-flex flex-column justify-space-between rune-shop-card" elevation="2">
                <div class="d-flex justify-space-between align-start mb-2">
                  <div class="flex-grow-1 pr-2" style="min-width: 0">
                    <v-card-title class="py-1 my-0 text-truncate">{{ rune.name }}</v-card-title>
                    <v-card-subtitle class="py-1 my-0">Runen Kosten: {{ rune.cost }}</v-card-subtitle>
                    <v-card-subtitle class="py-1 my-0">Runengrad: {{ rune.rarity }}</v-card-subtitle>
                    <v-card-subtitle class="py-1 my-0">Runentyp: {{ rune.type }}</v-card-subtitle>
                    <v-card-subtitle class="py-1 my-0">Runen Effekte:</v-card-subtitle>
                  </div>

                  <div class="ml-2">
                    <v-img
                      :src="getItemImage(rune.icon, rune.type, rune.rarity)"
                      class="rounded rune-shop-image"
                      cover
                     />
                  </div>
                </div>
                    <div
                      v-for="effect in rune.effects"
                      :key="effect.id"
                      class="mb-3 pa-2 rounded"
                      style="background: rgba(0,0,0,0.05);"
                    >
                      <div class="font-weight-bold text-subtitle-2">
                        {{ effect.name }}
                      </div>

                      <div
                        v-for="attr in getVisibleAttributes(effect)"
                          :key="attr.index"
                          class="text-body-2"
                      >
                        {{ attr.label }}: {{ formatAttr(effect, attr.index) }}
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <v-card-subtitle class="py-1 my-0"> Runenbeschreibung: {{ rune.description }}</v-card-subtitle>
                    </div>
                <v-card-actions class="mt-3">
                  <v-btn color="primary" @click="buyRune(rune)" :block="$vuetify.breakpoint.xsOnly" :disabled="
                    waiting === 1 || isItemDisabled(rune)
                    ">
                    {{ isItemDisabled(rune) ? 'Bereits gekauft ✅' : 'Kaufen' }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-app>
    </div>
    <v-snackbar v-model="errorReedemReward" timeout="5000" color="red">
      {{ dynamicErrorMsg }}

      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="errorReedemReward = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="ReedemReward" timeout="3000" color="green">
      {{ dynamicReedemMsg }}

      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="ReedemReward = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';
import { getUnit } from '@/utils/runeUnits';
import UserStatsBar from '@/components/UserStatsBar.vue';

export default {
  name: 'RuneView',
  components: {
    UserStatsBar,
  },

  data: () => ({
    sendData: {},
    settings: [],
    intervalId: null,
    rewards_raw: [],
    userInput: '',
    showInputDialog: false,
    currentIndex: null,
    selectReward: null,
    errorReedemReward: false,
    dynamicErrorMsg: '',
    ReedemReward: false,
    dynamicReedemMsg: '',
    currentReedemRewards: [],
    redeemCounts: {},
    waiting: 0,
    socket: null,
  }),
  mounted() {
    this.loadShop(this.$route.params.id);
  },
  beforeRouteUpdate(to, from, next) {
    this.loadShop(to.params.id);
    next();
  },
  computed: {
    runes() {
      return [...this.rewards_raw].sort((a, b) => a.cost - b.cost);
    },
  },
  methods: {
    loadShop(id) {
      // Reset so the previous instance's runes/points never flash while the new instance loads.
      this.rewards_raw = [];
      this.sendData = { id };
      BackendService.loadRunes(this.sendData).then((data) => {
        console.log(data.data);
        this.rewards_raw = Array.isArray(data.data) ? data.data : [];
      }).catch(() => {
        console.log('Nicht eingeloggt?');
      }).finally(() => {
        this.$store.dispatch('refreshStatus');
      });
    },
    hasAttr1(effect) {
      return (
        effect.attribute1min !== undefined
        && effect.attribute1max !== undefined
        && effect.attribute1min !== effect.attribute1max
      );
    },
    hasAttr2(effect) {
      return (
        effect.attribute2min !== undefined
        && effect.attribute2max !== undefined
        && effect.attribute2min !== effect.attribute2max
      );
    },
    getUnit(slug, index) {
      return getUnit(this.$store.state, slug, index);
    },
    formatAttr(effect, index) {
      if (this.isCombined(effect)) {
        const unit2 = this.getUnit(effect.slug, 2);
        return `${effect.attribute1} % Chance auf ${effect.attribute2}${unit2}`;
      }

      const value = effect[`attribute${index}`];
      return `${value}${this.getUnit(effect.slug, index)}`;
    },
    getVisibleAttributes(effect) {
      // Spezialfall: luck_loyalty → nur ein kombinierter Effekt
      if (effect.slug === 'luck_loyalty') {
        return [{ index: 1, label: 'Effekt' }];
      }

      const attrs = [];

      if (this.hasAttr1(effect)) {
        attrs.push({ index: 1, label: 'Effekt' });
      }

      if (this.hasAttr2(effect)) {
        attrs.push({ index: 2, label: 'Effekt' });
      }

      return attrs;
    },
    isCombined(effect) {
      return (
        effect.attribute1min !== effect.attribute1max
        && effect.attribute2min !== effect.attribute2max
      );
    },
    isItemDisabled(item) {
      return (
        item.purchase === 1
      );
    },
    getItemImage(path, type, rarity) {
      if (path === null || path === '') {
        return this.getDefaultRuneImage(type, rarity);
      }
      return `${process.env.VUE_APP_BACKENDSERVICE_BASEURL}img/${path}`;
    },
    getDefaultRuneImage(type, rarity) {
      switch (`${type}_${rarity}`) {
        case 'Normal_1': return '/img/forge_rune/Runestone_Normal_1.png';
        case 'Normal_2': return '/img/forge_rune/Runestone_Normal_2.png';
        case 'Normal_3': return '/img/forge_rune/Runestone_Normal_3.png';
        case 'Bonus_1': return '/img/forge_rune/Runestone_Bonus_1.png';
        case 'Bonus_2': return '/img/forge_rune/Runestone_Bonus_2.png';
        case 'Bonus_3': return '/img/forge_rune/Runestone_Bonus_3.png';
        case 'Event_1': return '/img/forge_rune/Runestone_Event_1.png';
        case 'Event_2': return '/img/forge_rune/Runestone_Event_2.png';
        case 'Event_3': return '/img/forge_rune/Runestone_Event_3.png';
        default: return '/img/Custom_Logo/ThoFu_Bot_Logo_transparent_text_Crop.png';
      }
    },
    toEquipmentView() {
      this.$router.push({
        name: 'equipment_selection',
        params: { id: this.$route.params.id },
      });
    },
    buyRune(rune) {
      console.log('Kauf Rune!!!!');
      this.waiting = 1;
      console.log(rune);
      // console.log(userinput);
      // console.log('Belohnung einlösen:', reward);
      BackendService.buyRunes(rune).then((data) => {
        console.log(data.data);
        this.rewards_raw = data.data.runes;
        this.$store.commit('set_xp', data.data.xp);
        this.dynamicReedemMsg = 'Rune erfolgreich gekauft!';
        this.ReedemReward = true;
        this.waiting = 0;
      }).catch((error) => {
        // console.log(error.response.status);
        // console.log(error.response.data);
        if (error.response.status === 409 && error.response.data === 'user_has_not_enough_xp') {
          this.dynamicErrorMsg = 'Nicht genügend XP für die Rune!';
          this.errorReedemReward = true;
        }
        this.waiting = 0;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.giveaway {
  &_header {
    background-color: darkblue;
    color: white;
    text-align: center;
    width: 50vw;
    margin: 10px auto 0 auto;
  }

  &_body {
    text-align: center;
    width: 50vw;
    margin: 10px auto 0 auto;
  }
}

.card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-actions {
  margin-top: auto;
  /* Setzt die Margin für den oberen Bereich auf "auto" */
}

.v-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.3s ease;
}

.rune-shop-card {
  width: 100%;
}

.rune-shop-image {
  width: 100px;
  height: 100px;
  flex-shrink: 0;
}

@media (max-width: 599px) {
  .rune-shop-image {
    width: 64px;
    height: 64px;
  }
}
</style>
